import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";
import TitleContainerComponent from '../../components/layout/TitleContainerComponent';

function ApplicationContactView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Contacto', href: '' }
    ];

	return (
        <MainPageComponent requireAuthentication={false} path={breadcrumbPath} >
            <CenterCenterVerticalContainer>
                <div>
                    <TitleContainerComponent>
                        <h1>Contacto</h1>
                    </TitleContainerComponent>
                    <p>Empieza ahora a mejorar tus finanzas,
                        te ofrecemos una forma sencilla de hacerlo.</p>
                </div>
                
              
                    
            </CenterCenterVerticalContainer>
        </MainPageComponent>
	);
}

export default ApplicationContactView;